import { Link } from 'react-router-dom'

export function TermsPage() {
  return (
    <main className="mx-auto max-w-3xl space-y-6 p-8">
      <header>
        <h1 className="text-2xl font-semibold">Nutzungsbedingungen</h1>
      </header>

      <section className="space-y-3 text-sm leading-6 text-muted-foreground">
        <ul className="list-disc space-y-2 pl-5">
          <li>MindKeep wird als funktionierender Prototyp (Case) bereitgestellt.</li>
          <li>Die Nutzung erfolgt auf eigene Gefahr und ohne Gewährleistung.</li>
          <li>Lade keine vertraulichen Produktivdaten hoch.</li>
          <li>
            Deine Inhalte verbleiben in deinem eigenen Workspace und können jederzeit exportiert oder
            gelöscht werden.
          </li>
          <li>Missbrauch ist untersagt — insbesondere Rechtsverstösse und Angriffe auf den Dienst.</li>
        </ul>
        <p>
          Kontakt:{' '}
          <a
            className="font-medium text-foreground underline-offset-4 hover:underline"
            href="mailto:hartmut@huebner.io"
          >
            hartmut@huebner.io
          </a>
        </p>
        <p>
          Details regelt die Datenschutzerklärung auf{' '}
          <a
            className="font-medium text-foreground underline-offset-4 hover:underline"
            href="https://huebner.io/de/datenschutz"
            target="_blank"
            rel="noreferrer"
          >
            huebner.io
          </a>
          .
        </p>
      </section>

      <footer className="text-xs text-muted-foreground">
        <Link className="underline-offset-4 hover:underline" to="/legal/privacy">
          Datenschutzerklärung
        </Link>
        {' · '}
        <Link className="underline-offset-4 hover:underline" to="/legal/impressum">
          Impressum
        </Link>
      </footer>
    </main>
  )
}
